import { Chip, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Cancel, InfoOutlined, OpenInNew, ThumbDownAlt, ThumbUp, Update } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import React, { useEffect, useState } from "react";
import {
  BooleanInput,
  Button,
  NumberInput,
  SelectArrayInput,
  SelectInput,
  TextInput,
  Toolbar,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { CarrierType, GetCarrierType } from "../../../../Enums/CarrierType";
import { PbhSvcShipmentTypeEnum } from "../../../../Enums/PbhSvcShipmentType";
import { ServiceableStatu } from "../../../../Enums/ServiceableStatus";
import { useAppDataProvider } from "../../../../dataprovider";
import { PbhRequestServiceablePutModel } from "../../Models/PbhRequestServiceableModel";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import ServiceableStatusChip from "../Statu/ServiceableStatusChip";
import { PbhRequestFileType } from "../../../../../src/Enums/PbhRequestFileType";
import OrderTypesEnum from "../../../../../src/Enums/OrderTypes";
import { GetRejectionQuarantinedRemoveReasonSubType } from "../../../../../src/Enums/RemoveReasonSubType";
import { PbhRequestStatus } from "../../../../../src/Enums/PbhRequestStatus";
import { Roles } from "../../../../../src/Enums/Roles";
import { OwnerType, OwnerTypeDesc } from "../../../../../src/Enums/OwnerTypes";
import { getTkCargoTrackingUrl } from "../../../../Helper/TkCargoHelper";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const ServiceableUpdate = props => {
  const [loading, setLoading] = useState(false);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingReject, setLoadingReject] = useState(false);
  const { user } = useAuth();
  const classes = useStyles();
  const [isButtonShow, setIsAButtonShow] = useState(props.serviceable?.status !== ServiceableStatu.Offered);
  const [serviceableFormDisabled, setServiceableFromDisabled] = useState(true);
  const [isCustomerFieldDisabled, setIsCustomerFieldDisabled] = useState(true);
  const [orderNumberAndTypeVisible, setOrderNumberAndTypeVisible] = useState(
    props?.serviceable?.shipmentType === Number(PbhSvcShipmentTypeEnum.DropShipment)
  );
  const [approveButtonShown, setApproveButtonShown] = useState(false);
  const [shipmentTypeList, setShipmentTypeList] = React.useState<any[]>([]);
  const [orderTypeList, setOrderTypeList] = useState<any[]>([]);
  const [showPhotoPartWarning, setShowPhotoPartWarning] = useState(false);

  // const { canPerform: canEditOnlyShow } = useHasAccess(SourceRequestOrder, "editonlyshow");
  const aarFlyDubai = OwnerTypeDesc.find(x => x.Value == OwnerType.AARFLYDB)?.Description;
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const requestId = props.requestId;
  const isDomesticDestination = props?.requestDetail?.isDomesticDestination;

  React.useEffect(() => {
    GetShipmentTypeList();
    GetOrderTypeList();
    if (user?.isCustomer === true) {
      setIsCustomerFieldDisabled(false);
    }
  }, []);

  useEffect(() => {
    setIsAButtonShow(props.serviceable?.status !== ServiceableStatu.Offered);
  }, [props.serviceable]);

  // Monitor file changes and re-validate reject reasons if files are uploaded/removed
  useEffect(() => {
    if (showPhotoPartWarning) {
      const hasPhotoPartFile = props?.requestDetail?.pbhRequestOrderFiles?.some(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.PartPhoto
      );
      if (hasPhotoPartFile) {
        setShowPhotoPartWarning(false);
      }
    }
  }, [props?.requestDetail?.pbhRequestOrderFiles, showPhotoPartWarning]);

  const AcceptOrRejectButtonClick = (serviceable, isApproved, form) => e => {
    if (AcceptOrRejectValidation(serviceable) === false) {
      return false;
    }

    if (isApproved) {
      setLoadingAccept(true);
    } else {
      setLoadingReject(true);
    }
    AcceptOrRejectServiceable(serviceable, isApproved, form);
  };

  const GetShipmentTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: PbhSvcShipmentTypeEnum.PbhSvcShipmentType },
      })
      .then(result => {
        setShipmentTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };
  const GetOrderTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: OrderTypesEnum.OrderTypes },
      })
      .then(result => {
        setOrderTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };

  const AcceptOrRejectServiceable = async (serviceable, isApproved, form) => {
    let requestServiceableUpdateModel: any;
    requestServiceableUpdateModel = { ...serviceable };
    requestServiceableUpdateModel.status = isApproved === true ? ServiceableStatu.Accepted : ServiceableStatu.Rejected;
    requestServiceableUpdateModel.updatedBy = user?.employeeId;
    requestServiceableUpdateModel.updatedDate = new Date();
    requestServiceableUpdateModel.rejectReasons = requestServiceableUpdateModel.rejectReasons
      ? requestServiceableUpdateModel.rejectReasons.toString()
      : "";

    if (
      requestServiceableUpdateModel.status === ServiceableStatu.Rejected &&
      (!requestServiceableUpdateModel.rejectionNote || !requestServiceableUpdateModel.rejectReasons)
    ) {
      notify(`You need to fill in Rejection Note!`, "warning");
      setLoadingReject(false);
      return;
    }
    dataProvider
      .putPbhRequestServiceable(requestServiceableUpdateModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        setIsAButtonShow(true);
        history.push("/pbhrequestorders/" + requestId + "/1");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => {
        setLoading(false);
        setLoadingAccept(false);
        setLoadingReject(false);
        setTimeout(() => {
          form?.restart?.(getInitialValues());
        }, 50);
      });
  };

  const UpdateServiceable = (e, form) => {
    let requestPbhServiceableUpdateModel: PbhRequestServiceablePutModel = new PbhRequestServiceablePutModel();
    requestPbhServiceableUpdateModel.id = props.serviceable.id;
    requestPbhServiceableUpdateModel.RequestId = props.serviceable.requestId;
    requestPbhServiceableUpdateModel.Status = props.serviceable.status;
    if (orderNumberAndTypeVisible) {
      requestPbhServiceableUpdateModel.OrderNumber = e.orderNumber;
      requestPbhServiceableUpdateModel.OrderType = e.orderType;
    }
    requestPbhServiceableUpdateModel.IsCid = e.isCid;
    requestPbhServiceableUpdateModel.CidDescription = e.cidDescription;
    requestPbhServiceableUpdateModel.updatedBy = user?.employeeId;
    requestPbhServiceableUpdateModel.ShipmentType = Number(e.shipmentType);
    requestPbhServiceableUpdateModel.updatedDate = new Date();
    if (user?.isCustomer === false) {
      requestPbhServiceableUpdateModel.Awb = e.awb;
      requestPbhServiceableUpdateModel.CarrierEnum = e.carrierEnum;
      requestPbhServiceableUpdateModel.EstimatedDeliveryDate = e.estimatedDeliveryDate;
      requestPbhServiceableUpdateModel.FlightNo = e.flightNo;
      requestPbhServiceableUpdateModel.Pn = e.pn;
      requestPbhServiceableUpdateModel.Sn = e.sn;
      requestPbhServiceableUpdateModel.XoNo = e.xoNo?.toString();
      requestPbhServiceableUpdateModel.ForwardDateToCarrier = e.forwardDateToCarrier;
      requestPbhServiceableUpdateModel.RejectionNote = props.serviceable.rejectionNote;
      requestPbhServiceableUpdateModel.RejectReasons = props.serviceable.rejectReasons;
      requestPbhServiceableUpdateModel.TtRejectionNote = e.ttRejectionNote;
    } else {
      requestPbhServiceableUpdateModel.Awb = props.serviceable.awb;
      requestPbhServiceableUpdateModel.CarrierEnum = props.serviceable.carrierEnum;
      requestPbhServiceableUpdateModel.EstimatedDeliveryDate = props.serviceable.estimatedDeliveryDate;
      requestPbhServiceableUpdateModel.FlightNo = props.serviceable.flightNo;
      requestPbhServiceableUpdateModel.Pn = props.serviceable.pn;
      requestPbhServiceableUpdateModel.Sn = props.serviceable.sn;
      requestPbhServiceableUpdateModel.XoNo = props.serviceable.xoNo?.toString();
      requestPbhServiceableUpdateModel.ForwardDateToCarrier = props.serviceable.forwardDateToCarrier;
      requestPbhServiceableUpdateModel.RejectionNote = e.rejectionNote;
      requestPbhServiceableUpdateModel.RejectReasons = e.rejectReasons;
    }

    if (UpdateValidation(requestPbhServiceableUpdateModel)) {
      PutUpdate(requestPbhServiceableUpdateModel, form);
    }
  };

  const UpdateValidation = (pbhRequestServiceablePutModel: PbhRequestServiceablePutModel) => {
    if (pbhRequestServiceablePutModel?.IsCid) {
      if (pbhRequestServiceablePutModel.CidDescription == null) {
        notify(`Cid Remark is required`, "error");
        return false;
      }
    }

    return true;
  };

  const AcceptOrRejectValidation = serviceable => {
    if (serviceable?.isCid) {
      if (serviceable.cidDescription == null) {
        notify(`Cid Remark is required`, "error");
        return false;
      }
    }

    if (showPhotoPartWarning) {
      notify(
        `Part Photo file is required when rejection reason is "Part Received as Damaged" or "PN/SN Mismatch Discrepancy"`,
        "error"
      );
      return false;
    }

    return true;
  };

  const PutUpdate = async (putModel: PbhRequestServiceablePutModel, form) => {
    setLoading(true);
    dataProvider
      .putPbhRequestServiceable(putModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        history.push("/pbhrequestorders/" + requestId + "/1");
        setIsAButtonShow(true);
        setApproveButtonShown(false);
        setServiceableFromDisabled(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          form?.restart?.(getInitialValues());
        }, 50);
      });
  };

  const openEditableFields = e => {
    setApproveButtonShown(true);
    if (user?.isCustomer === false) {
      setServiceableFromDisabled(false);
    } else {
      setIsCustomerFieldDisabled(false);
    }
  };

  const cancelUpdate = e => {
    setApproveButtonShown(false);
    setServiceableFromDisabled(true);
    setIsCustomerFieldDisabled(true);
  };
  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };
  const onChangeShipType = e => {
    if (Number(e.target.value) === Number(PbhSvcShipmentTypeEnum.DropShipment)) {
      setOrderNumberAndTypeVisible(true);
    } else {
      setOrderNumberAndTypeVisible(false);
    }
  };

  const onChangeRejectReasons = value => {
    if (user?.isCustomer && value && Array.isArray(value) && value.length > 0) {
      const requiresPhotoPartFile = value.some(
        reason => reason === "Part Received as Damaged" || reason === "PN/SN Mismatch Discrepancy"
      );

      if (requiresPhotoPartFile) {
        const hasPhotoPartFile = props?.requestDetail?.pbhRequestOrderFiles?.some(
          x =>
            x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
            x.pbhRequestFileTypeEnum === PbhRequestFileType.PartPhoto
        );
        setShowPhotoPartWarning(!hasPhotoPartFile);
      } else {
        setShowPhotoPartWarning(false);
      }
    } else {
      setShowPhotoPartWarning(false);
    }
  };

  const isDisabledProcess = values => () => {
    if (props.isPageDisabled) {
      return true;
    }
    if (props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled) {
      return true;
    }
    if (values.isCid === true) {
      var cidFileCheck = props?.requestDetail?.pbhRequestOrderFiles?.some?.(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.Cid
      );
      if (cidFileCheck == false) {
        return true;
      }
    }

    if (showPhotoPartWarning) {
      return true;
    }

    return false;
  };

  // Transform initial values to convert rejectReasons string to array
  const getInitialValues = () => {
    if (!props.serviceable) return {};

    const initialValues = { ...props.serviceable };

    // Convert rejectReasons from string to array if needed
    if (initialValues.rejectReasons && typeof initialValues.rejectReasons === "string") {
      initialValues.rejectReasons = initialValues.rejectReasons
        .split(",")
        .map(r => r.trim())
        .filter(r => r);
    } else if (!initialValues.rejectReasons) {
      initialValues.rejectReasons = [];
    }

    return initialValues;
  };

  return (
    <>
      <Form
        initialValues={getInitialValues()}
        keepDirtyOnReinitialize
        onSubmit={e => {}}
        render={({ handleSubmit, form, values }) => {
          const onFormSubmit = e => UpdateServiceable(e, form);

          return (
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <Grid container xs={12} sm={12} justifyContent="center">
                      <SectionTitle label="Serviceable Info" />
                    </Grid>
                    <Grid container xs={12} sm={12} justifyContent="flex-end" style={{ margin: 5 }}>
                      <ServiceableStatusChip serviceable={props.serviceable} />
                    </Grid>
                    <Grid container xs={12} sm={12} justifyContent="flex-end" style={{ margin: 5 }}>
                      {values?.isCid === true &&
                        !props?.requestDetail?.pbhRequestOrderFiles?.some?.(
                          x =>
                            x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
                            x.pbhRequestFileTypeEnum === PbhRequestFileType.Cid
                        ) && (
                          <Chip
                            key={9999992}
                            color="primary"
                            variant="outlined"
                            label="If you have enabled the 'is Cid' field, please upload a file of type 'Cid'."
                            icon={<InfoOutlined />}
                          />
                        )}
                    </Grid>
                  </Grid>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="pn"
                        label="PN"
                        fullWidth
                        resettable
                        variant="outlined"
                        validate={required()}
                        disabled={props.isPageDisabled || serviceableFormDisabled}
                      />
                      <TextInput
                        source="sn"
                        label="SN"
                        fullWidth
                        resettable
                        variant="outlined"
                        validate={required()}
                        disabled={props.isPageDisabled || serviceableFormDisabled}
                      />
                      <TextInput
                        source="flightNo"
                        label="Flight No"
                        fullWidth
                        resettable
                        variant="outlined"
                        disabled={props.isPageDisabled || serviceableFormDisabled}
                      />
                      <CustomDatetime
                        fullWidth
                        source="forwardDateToCarrier"
                        label="Forward Date To Carrier"
                        inputVariant={"dialog"}
                        variant="outlined"
                        showTime
                        validate={required()}
                        onChange={resetValidate(form)}
                        onBlur={resetValidate(form)}
                        disabled={props.isPageDisabled || serviceableFormDisabled}
                      />
                      <SelectInput
                        source="shipmentType"
                        label="Shipment Type"
                        choices={shipmentTypeList}
                        optionText="parameterDesc"
                        optionValue="parameterValue"
                        fullWidth
                        variant="outlined"
                        validate={required()}
                        onChange={onChangeShipType}
                        disabled={props.isPageDisabled || serviceableFormDisabled}
                      />
                      {orderNumberAndTypeVisible && (
                        <TextInput
                          source="orderNumber"
                          label="Order Number"
                          fullWidth
                          resettable
                          variant="outlined"
                          validate={required()}
                          disabled={props.isPageDisabled || serviceableFormDisabled}
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      {props.serviceable?.awb && !user?.isCustomer && (
                        <a
                          href={getTkCargoTrackingUrl(props.serviceable.awb)}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#C90C0F", textDecoration: "none", fontSize: "12px" }}
                        >
                          <OpenInNew style={{ fontSize: 12, marginRight: 4 }} />
                          Track on TK Cargo
                        </a>
                      )}
                      <TextInput
                        source="awb"
                        label="AWB No"
                        fullWidth
                        resettable
                        variant="outlined"
                        validate={isDomesticDestination && required()}
                        disabled={props.isPageDisabled || serviceableFormDisabled}
                      />
                      <NumberInput
                        source="xoNo"
                        label="XO Number"
                        fullWidth
                        resettable
                        variant="outlined"
                        max={99999999}
                        validate={[
                          value => (!value || value.toString().length <= 8 ? undefined : "Maximum 8 digits allowed"),
                        ]}
                        disabled={props.isPageDisabled || serviceableFormDisabled}
                      />
                      <SelectInput
                        source="carrierEnum"
                        label="Carrier"
                        choices={GetCarrierType}
                        optionText="Description"
                        optionValue="Value"
                        fullWidth
                        variant="outlined"
                        validate={required()}
                        disabled={props.isPageDisabled || serviceableFormDisabled}
                      />
                      <CustomDatetime
                        fullWidth
                        source="estimatedDeliveryDate"
                        label="Estimated Delivery Date"
                        inputVariant={"dialog"}
                        variant="outlined"
                        showTime
                        minDate={values.forwardDateToCarrier}
                        validate={[minValue(values.forwardDateToCarrier), required()]}
                        onChange={resetValidate(form)}
                        onBlur={resetValidate(form)}
                        disabled={props.isPageDisabled || serviceableFormDisabled}
                      />
                      {orderNumberAndTypeVisible && (
                        <SelectInput
                          source="orderType"
                          label="Order Type"
                          choices={orderTypeList}
                          optionText="parameterDesc"
                          optionValue="parameterValue"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                          disabled={props.isPageDisabled || serviceableFormDisabled}
                        />
                      )}
                      <BooleanInput
                        label="Received as damaged, but it will be installed on aircraft"
                        source="isCid"
                        disabled={props.isPageDisabled || isCustomerFieldDisabled}
                      />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="rejectionNote"
                        label="Rejection Note"
                        multiline
                        minRows={3}
                        inputProps={{ maxLength: 2000 }}
                        fullWidth
                        resettable
                        variant="outlined"
                        disabled={props.isPageDisabled || isCustomerFieldDisabled}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <SelectArrayInput
                        source="rejectReasons"
                        choices={GetRejectionQuarantinedRemoveReasonSubType}
                        optionText="Description"
                        optionValue="Description"
                        disabled={props.isPageDisabled || isCustomerFieldDisabled}
                        fullWidth
                        onChange={e => {
                          const value = e?.target?.value || e;
                          onChangeRejectReasons(value);
                        }}
                      />
                      <Grid container style={{ marginTop: 8 }}>
                        {showPhotoPartWarning && (
                          <Chip
                            key={9999993}
                            color="primary"
                            variant="outlined"
                            label="Please upload photos for serviceable part discrepancy!"
                            icon={<InfoOutlined />}
                          />
                        )}
                      </Grid>
                      {props.serviceable?.status === ServiceableStatu.Rejected && (
                        <TextInput
                          source="ttRejectionNote"
                          label="TT Rejection Note"
                          multiline
                          minRows={3}
                          inputProps={{ maxLength: 2000 }}
                          fullWidth
                          resettable
                          variant="outlined"
                          disabled
                        />
                      )}
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      {values.isCid == true && (
                        <TextInput
                          source="cidDescription"
                          label="Cid Remark"
                          multiline
                          minRows={3}
                          inputProps={{ maxLength: 2000 }}
                          fullWidth
                          resettable
                          variant="outlined"
                          disabled={props.isPageDisabled || isCustomerFieldDisabled}
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Separator />
                  <Toolbar {...props} placeholder="" classes={classes}>
                    {user?.isCustomer && !user?.roles?.some(x => x == Roles.EightWings) && (
                      <>
                        <Button
                          label={loading ? "Updating!" : "Update"}
                          disabled={loading || isDisabledProcess(values)()}
                          size="medium"
                          variant="contained"
                          onClick={() => onFormSubmit(values)}
                          style={{ margin: "8px", background: "seagreen" }}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                        </Button>
                        <Button
                          label={loadingAccept ? "Serviceable is Accepted!" : "Accept Serviceable"}
                          disabled={loadingAccept || isButtonShow || isDisabledProcess(values)()}
                          size="medium"
                          variant="contained"
                          onClick={AcceptOrRejectButtonClick(
                            {
                              ...props.serviceable,
                              ...{ isCid: values?.isCid, cidDescription: values?.cidDescription },
                            },
                            true,
                            form
                          )}
                          style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "seagreen" }}
                        >
                          {loadingAccept ? <CircularProgress size="2rem" color="secondary" /> : <ThumbUp />}
                        </Button>
                        <Button
                          label={loadingReject ? "Serviceable is Rejected!" : "Reject Serviceable"}
                          disabled={loadingReject || isButtonShow || isDisabledProcess(values)()}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={AcceptOrRejectButtonClick(
                            {
                              ...props.serviceable,
                              ...{
                                rejectionNote: values?.rejectionNote,
                                isCid: values?.isCid,
                                cidDescription: values?.cidDescription,
                                rejectReasons: values?.rejectReasons,
                              },
                            },
                            false,
                            form
                          )}
                          style={{ margin: "8px" }}
                        >
                          {loadingReject ? <CircularProgress size="2rem" color="secondary" /> : <ThumbDownAlt />}
                        </Button>
                      </>
                    )}
                    {(!user?.isCustomer ||
                      (user?.roles?.some(x => x == Roles.EightWings) &&
                        props?.requestDetail?.ownerCode == aarFlyDubai)) &&
                      approveButtonShown === false && (
                        <>
                          <Button
                            label="Edit Serviceable"
                            disabled={loading || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled}
                            size="medium"
                            variant="contained"
                            style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "#ffc107" }}
                            onClick={openEditableFields}
                          >
                            {<Update />}
                          </Button>
                        </>
                      )}
                    {approveButtonShown === true && (
                      <>
                        <Button
                          label={loading ? "Serviceable Info is updating!" : "Update Serviceable  Info "}
                          disabled={loading || isDisabledProcess(values)()}
                          size="medium"
                          variant="contained"
                          onClick={() => onFormSubmit(values)}
                          style={{ margin: "8px", background: "seagreen" }}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                        </Button>
                        <Button
                          label={loading ? "Cancel!" : "Cancel "}
                          disabled={loading || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={cancelUpdate}
                          style={{ margin: "8px" }}
                        >
                          {<Cancel />}
                        </Button>
                      </>
                    )}
                  </Toolbar>
                </Grid>
              </Grid>
            </form>
          );
        }}
      />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Serviceable} />
    </>
  );
};

const PbhRequestServiceableUpdate = props => {
  return (
    <ServiceableUpdate
      requestDetail={props?.requestDetail}
      serviceable={props?.serviceable}
      requestId={props?.requestId}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default PbhRequestServiceableUpdate;
